/* Lunelle - Confettis discrets aux deux moments de recompense
   1. reclamation du 2e sac offert   : clic sur [data-lunelle-bogo-variant]
   2. reclamation du porte-monnaie   : clic sur [data-gift-add] en etat unlocked

   POURQUOI : le tiroir affiche deja une barre de progression vers 69 EUR, des
   pastilles OFFERT et des etats verrouille / debloque / reclame. Cette mecanique
   n'avait aucun temps fort a l'arrivee. Les confettis ferment la boucle.

   CANVAS HORS DU TIROIR, C'EST OBLIGATOIRE : les deux moments declenchent
   renderContents(), qui reinjecte le HTML du tiroir. Un canvas pose DANS le
   tiroir serait detruit en pleine animation, exactement au mauvais instant. Il
   est donc ajoute a <body>.

   Z-INDEX : le tiroir est deja a 2147483647, le maximum d'un entier 32 bits
   signe. On ne peut donc pas passer AU-DESSUS par le z-index. Le canvas prend
   la meme valeur et est ajoute en DERNIER enfant de <body> : a z-index egal,
   c'est l'ordre du DOM qui tranche, donc il peint par-dessus le tiroir.

   COUT GPU : le tiroir porte deja un backdrop-filter blur(8.5px) plein ecran et
   quatre .ugc__popup floutes derriere lui ; l'ouverture coute deja une tache
   longue d'environ 290 ms. Deux precautions : le canvas est dimensionne sur la
   SURFACE qui contient le clic (le panneau du tiroir ou celui des ventes
   croisees), jamais sur tout l'ecran, et il est retire des la fin de
   l'animation pour ne rien laisser en composition.

   DECLENCHEMENT OPTIMISTE, en phase de CAPTURE : la reclamation du sac
   enchaine environ 5 allers-retours cart.js ; attendre la fin detacherait
   l'animation du geste. On part donc des le clic.

   DELAI DE GARDE de 10 s : les deux recompenses sont separees (le 2e sac laisse
   le panier a 59,99 EUR, sous le seuil de 69 EUR), mais le carrousel de ventes
   croisees est dans le MEME tiroir, quelques pixels sous la carte de
   reclamation. Un client rapide peut donc reclamer le sac, ajouter le sac de
   rangement a 11,99 EUR, passer a 71,98 EUR et reclamer le porte-monnaie en
   quelques secondes. Deux salves coup sur coup en feraient trop.

   prefers-reduced-motion : aucune animation, on ne fait rien du tout.

   Essai manuel depuis la console :  lunelleCelebrate()
*/
(function () {
  if (window.__lunelleCelebrateBound) return;
  window.__lunelleCelebrateBound = true;

  var COOLDOWN_MS = 10000;
  var DURATION_MS = 1100;
  var COUNT = 34;
  var GRAVITY = 0.22;
  var DRAG = 0.985;
  var FADE_FROM = 0.6; /* opaque jusqu'a 60 % puis fondu */
  var Z = 2147483647;

  /* Palette de marque uniquement. Pas d'arc-en-ciel : sur cette marque, ca ferait
     bon marche. Vert d'offre (identique aux badges), creme, or sourd. */
  var COLORS = ['#3F6B52', '#F5EDE1', '#C9A227'];

  var lastAt = 0;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Surface d'accueil : celle qui contient reellement le clic. A defaut, l'ecran.

     PAS <cart-drawer> : mesure le 2026-08-14, cet element est le VOILE plein
     ecran (1280x720, c'est lui qui porte le backdrop-filter). Le panneau qui
     glisse est .drawer__inner (340x720). Viser le panneau divise la surface
     composee par environ 3,8, ce qui est precisement le but. */
  function surfaceFor(originEl) {
    var host = originEl && originEl.closest ? originEl.closest('cart-drawer .drawer__inner, [data-gtl-panel]') : null;
    if (host) {
      var r = host.getBoundingClientRect();
      if (r.width > 2 && r.height > 2) {
        return { left: r.left, top: r.top, w: r.width, h: r.height };
      }
    }
    return { left: 0, top: 0, w: window.innerWidth, h: window.innerHeight };
  }

  function burst(originEl) {
    if (reducedMotion()) return false;

    var now = Date.now();
    if (now - lastAt < COOLDOWN_MS) return false;
    lastAt = now;

    var box = surfaceFor(originEl);

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.setAttribute('data-lunelle-celebrate', '');
    canvas.style.cssText =
      'position:fixed;left:' + box.left + 'px;top:' + box.top + 'px;' +
      'width:' + box.w + 'px;height:' + box.h + 'px;' +
      'pointer-events:none;z-index:' + Z + ';';

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(box.w * dpr);
    canvas.height = Math.round(box.h * dpr);

    /* Dernier enfant de <body> : a z-index egal avec le tiroir, l'ordre du DOM gagne. */
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    if (!ctx) { canvas.parentNode && canvas.parentNode.removeChild(canvas); return false; }
    ctx.scale(dpr, dpr);

    /* Origine du jet : le centre de l'element clique, ramene aux coordonnees du canvas. */
    var ox = box.w / 2;
    var oy = box.h / 3;
    if (originEl && originEl.getBoundingClientRect) {
      var r = originEl.getBoundingClientRect();
      if (r.width || r.height) {
        ox = r.left + r.width / 2 - box.left;
        oy = r.top + r.height / 2 - box.top;
      }
    }

    var parts = [];
    for (var i = 0; i < COUNT; i++) {
      /* Entre -140 et -40 degres : vers le haut, ouvert des deux cotes. */
      var ang = (-140 + Math.random() * 100) * Math.PI / 180;
      var spd = 4 + Math.random() * 5;
      parts.push({
        x: ox,
        y: oy,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd,
        w: 3 + Math.random() * 2,
        h: 6 + Math.random() * 3,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        c: COLORS[i % COLORS.length]
      });
    }

    var raf = 0;
    var start = 0;
    var done = false;

    function teardown() {
      if (done) return;
      done = true;
      if (raf) cancelAnimationFrame(raf);
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }

    function frame(t) {
      if (!start) start = t;
      var elapsed = t - start;
      if (elapsed >= DURATION_MS) { teardown(); return; }

      var progress = elapsed / DURATION_MS;
      ctx.clearRect(0, 0, box.w, box.h);
      ctx.globalAlpha = progress < FADE_FROM ? 1 : 1 - (progress - FADE_FROM) / (1 - FADE_FROM);

      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        p.vy += GRAVITY;
        p.vx *= DRAG;
        p.vy *= DRAG;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      raf = requestAnimationFrame(frame);
    }

    raf = requestAnimationFrame(frame);

    /* Filet de securite : si l'onglet passe en arriere-plan, rAF s'arrete et le
       canvas resterait en composition. On le retire quoi qu'il arrive.
       Verifie le 2026-08-14 : dans un onglet non visible, rAF ne tourne jamais
       (0 tick en 500 ms) et c'est bien ce delai qui nettoie. */
    setTimeout(teardown, DURATION_MS + 500);
    return true;
  }

  /* Phase de CAPTURE : on part avant les gestionnaires de reclamation, qui
     appellent stopPropagation() et repeignent ensuite tout le tiroir. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var bag = target.closest('[data-lunelle-bogo-variant]');
    if (bag && !bag.disabled) { burst(bag); return; }

    var add = target.closest('[data-gift-add]');
    if (add) {
      var gift = add.closest('[data-lunelle-gift]');
      /* Uniquement au moment de la reclamation : ni verrouille, ni deja reclame. */
      if (gift && gift.getAttribute('data-state') === 'unlocked') burst(add);
    }
  }, true);

  /* Essai manuel / apercu. Renvoie false si le delai de garde l'a bloque. */
  window.lunelleCelebrate = function (el) {
    return burst(el || document.querySelector('[data-lunelle-gift]') || document.body);
  };
})();
